module.exports = __webpack_public_path__ + "media/lane_change.21931d1a.mp4";